import {
  Component, ChangeDetectionStrategy, Input,
} from '@angular/core'
import {
  Icon, iconArrowsLeft, iconArrowsRight,
} from '@knorr-bremse-portals/icons'

import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon'

@Component({
  selector: '[kb-standalone-link]',
  templateUrl: './standalone-link.component.html',
  styleUrls: ['./standalone-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class StandaloneLinkComponent {
  @Input() public direction: 'back' | 'forward' = 'forward'
  @Input() public icon?: Icon

  protected iconBack = iconArrowsLeft
  protected iconForward = iconArrowsRight
}
